import { useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Inietta dinamicamente nel <head> un JSON-LD con aggregateRating
 * basato su recensioni reali Google (sync da Places API).
 *
 * Senza questo, lo schema.org Organization non ha rating → niente ⭐ in SERP.
 * Con questo, Google legge il rating live e lo mostra nei rich snippet.
 *
 * Component "headless": non renderizza niente.
 */
export default function GoogleAggregateRatingSchema() {
  useEffect(() => {
    let mounted = true;
    const inject = async () => {
      try {
        const r = await axios.get(`${API}/gbp/aggregate-rating`);
        if (!mounted || !r.data?.available) return;
        const { rating, review_count } = r.data;

        // Rimuovi eventuale script precedente (idempotenza in dev hot-reload)
        const existing = document.getElementById("ld-aggregate-rating");
        if (existing) existing.remove();

        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "ld-aggregate-rating";
        script.textContent = JSON.stringify({
          "@context": "https://schema.org",
          "@type": "InsuranceAgency",
          "@id": "https://www.colucciassicuratori.com/#organization",
          aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: rating,
            reviewCount: review_count,
            bestRating: 5,
            worstRating: 1,
          },
        });
        document.head.appendChild(script);
      } catch (e) {
        // Silent fail: rich snippet sono nice-to-have, non blocchiamo niente
      }
    };
    inject();
    return () => {
      mounted = false;
      const existing = document.getElementById("ld-aggregate-rating");
      if (existing) existing.remove();
    };
  }, []);

  return null;
}
